
import React, { Component } from 'react';
import * as ReconAction from '../actions/ReconAction';
import ReconStore from '../stores/ReconStore';
import * as MenuAction from '../actions/MenuAction';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import ReactPaginate from 'react-paginate';
import SDIConstants from '../SDIConstants';
import { withTranslation, Trans } from 'react-i18next'
import Switch from '@material-ui/core/Switch';
import swal from 'sweetalert';
let isFinalize = false;
//let popupDoneClick = false;
let isPageload = true;
let finalQtyCheck = true;

//bug 4209 -Yuvarani K
let words = [];
let Storage_Area = "";
let Store_level_1 = "";
let Store_level_2 = "";
let Store_level_3 = "";
let Store_level_4 = "";
let currentPagePath;


class ReconComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            PageGridArr: [],
            UnupdatedGridArr: [],
            UpdateAgree: "",
            EventArray: [],
            CribArray: [],
            ActionArray: [],
            totalCount: "0",
            itemCount: "10",
            Itemarray: [],
            pageCount: 0,
            pageNo: "1",
            qtyvalue: " ",
            SearchBy: " ",
            srchTxt: " ",
            toggleChecked: false,
            chkboxcheck: false,
            ActionNew: " ",
            sucpopItem: "",
            sucpopMsg: "",
            ReconGridArr: [],
            cribselected: "--Select--",
            eventselected: "",
            actionvalue: " ",
            actionname: " ",
            actqty: " ",
            qtyUpdated: "",
            actionUpdated: "",
            ItemUpdated: false,
            GridData: false,//WW-485 CYCLE COUNT FINALIZATION PAVITHRA R[09/02/2022],
            CountedItemReadyForUpdate: 0,
            finaldttm: "",
            action: "",
            countstatus: "",
            finalization: "",
            actualGridData: [],
            //isPageload: true //CPW-95 Vishwa S
            isFavorited: false,
            STrDisplayName: "All"


        }
    }
    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        $(`#exportID`).prop('disabled', true)
        $(`#finalizID`).prop('disabled', true)


        //   $(`#finalize_modal`).modal('hide');
        //  $(`#saveID`).prop('disabled', true)
        $(`#countevent`).prop('disabled', false)
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        //this.LoadSearchResults()
        //document.getElementById("Counted-tab"). 
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        ReconAction.getCurrentFavPage(getFavPageBO);
        this.ReconPageLoadData();
        ReconStore.on('Reconpageload', this.ReconPageLoadDataResponse);
        ReconStore.on('Recongridload', this.ReconGridLoadDataResponse);
        ReconStore.on('Reconupdate', this.ReconUpdateResponse);
        ReconStore.on('Export', this.FileExport);
        ReconStore.on('ReconSearch', this.ReconSearchResponse);
        ReconStore.on('ReconLoad', this.ReconLoadResponse);
        ReconStore.on('ReconFinalz', this.ReconFinalzResponse);
        ReconStore.on('favpage', this.loadFavPageResponse.bind(this));
        ReconStore.on('updateFavPage', this.updateFavPageResponse.bind(this));

    }
    componentWillUnmount() {
        ReconStore.removeListener('Reconpageload', this.ReconPageLoadDataResponse);
        ReconStore.removeListener('Recongridload', this.ReconGridLoadDataResponse);
        ReconStore.removeListener('Reconupdate', this.ReconUpdateResponse);
        ReconStore.removeListener('Export', this.FileExport);
        ReconStore.removeListener('ReconSearch', this.ReconSearchResponse);
        ReconStore.removeListener('ReconLoad', this.ReconLoadResponse);
        ReconStore.removeListener('ReconFinalz', this.ReconFinalzResponse);
        ReconStore.on('favpage', this.loadFavPageResponse.bind(this));
        ReconStore.on('updateFavPage', this.updateFavPageResponse.bind(this));

    }
    handlePageClick = (data) => {
        //debugger

        //CPW-95 Vishwa S
        //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //this.UpdateClick();
        //debugger
        let pageNo = data.selected + 1;
        this.setState({ pageNo: pageNo });

    };
    ReconSearchResponse = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let ReconResponse = JSON.parse(ReconStore.SearchRecon);
        let Reconaray = [];
        let itemreadyforupdate = parseInt(ReconResponse.itemupdate[0].itemupdatecount);
        let ItemReadyCount = 0;
        if (ReconResponse.Table != null && ReconResponse.Table != undefined) {
            Reconaray = ReconResponse.Table;
        }
        let actionary = ReconResponse.IsaActionDT;
        if (actionary != undefined) {
            if (actionary.length > 0) {
                this.setState({
                    ActionArray: actionary
                });
            }

        }
        if (Reconaray != undefined) {
            if (Reconaray.length > 0) {
                let tc = Reconaray[0].TOTAL_COUNT;
                Reconaray.forEach((value, index) => {
                    value.EnteredQty = value.ACTUAL_QUANTITY;
                    value.actionSelected = value.ISA_ACTION;

                });

                //let griddata = this.state.finalization
                //   if (griddata.length > 0) {
                //       griddata.forEach((value, index) => {
                //           if (value.ISA_UPDT_READY == 'TRUE') {
                //               ItemReadyCount += 1;
                //           }
                //       });
                //   }
                this.setState({
                    PageGridArr: Reconaray,
                    totalCount: tc,
                    pageCount: Math.ceil((tc > 0 ? tc : 0) / this.state.itemCount),
                    CountedItemReadyForUpdate: itemreadyforupdate,
                    pageNo: "1" //CPW-95 Vishwa S

                });
            }
            else {
                this.setState({
                    totalCount: "0"
                });
            };
        }


    }
    ReconLoadResponse = () => {
      
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let ReconResponse = JSON.parse(ReconStore.LoadRecon);
        let Reconaray = ReconResponse.Table;
        let actionary = ReconResponse.IsaActionDT;
        if (actionary != undefined && actionary != "") {
            if (actionary.length > 0) {
                this.setState({
                    ActionArray: actionary
                });
            }
        }

        if (Reconaray != undefined && Reconaray != "") {


            if (Reconaray.length > 0) {

                let tc = Reconaray[0].TOTAL_COUNT;
                Reconaray.forEach((value, index) => {
                    value.EnteredQty = value.ACTUAL_QUANTITY;
                    value.actionSelected = value.ISA_ACTION;
                });
                this.setState({
                    PageGridArr: Reconaray,
                    totalCount: tc,
                    pageCount: Math.ceil((tc > 0 ? tc : 0) / this.state.itemCount)

                });
            }
        }
        else {
            this.setState({
                totalCount: "0"
            });
        };
        this.ReconGridLoadData("1", this.state.cribselected, this.state.eventselected);
    }
    ReconFinalzResponse = () => {

        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
        //CPW-95 Vishwa S
        isFinalize = false;
        isPageload = false;
        let locEventselected = this.state.eventselected;
        let ReconResponse = JSON.parse(ReconStore.FinalzRecon);
        let ResponseResult = ReconResponse.Table1;
        let UpdateResponse = ResponseResult[0].lblDBErr1;
        //let Reconaray = ReconResponse.Table;
        //if (Reconaray != undefined) {
        //    if (Reconaray.length > 0) {
        //        let tc = Reconaray[0].TOTAL_COUNT;
        //        Reconaray.forEach((value, index) => {
        //            value.EnteredQty = value.ACTUAL_QUANTITY;
        //            value.actionSelected = value.ISA_ACTION;
        //        });
        //        this.setState({
        //            PageGridArr: Reconaray,
        //            totalCount: tc,
        //            pageCount: Math.ceil((tc > 0 ? tc : 0) / this.state.itemCount),
        //            eventselected: ReconResponse.IsaCountEvnt[0].CountEvent

        //        });
        //    }
        //    else {
        //        this.setState({
        //            totalCount: "0",
        //            eventselected: "",
        //            //isPageload: false
        //        });
        //    };
        //}

        //CPW-95 to set to default page after Finalization click, Vishwa S

        if (UpdateResponse.trim().toUpperCase() == "SUCCESSFULLY UPDATED") {
            this.setState({
                PageGridArr: [],
                totalCount: "0",
                eventselected: "",
                //isPageload: false
            })

            $('#no_event_modal').modal('show');
            document.getElementById("finaldetail").innerText = "Counting Event " + locEventselected + " has completed FINALIZATION."
        }
        else {
            $(`#cribID`).prop('disabled', false)
            $(`#finalizID`).prop('disabled', false)
            $(`#countevent`).prop('disabled', false)
            isPageload = true;
            $('#no_event_modal').modal('show');
            document.getElementById("finaldetail").innerText = "Counting Event " + locEventselected + " has failed FINALIZATION."
        }

        //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //this.ReconGridLoadData(this.state.pageNo, this.state.cribselected, locEventselected, "FINALIZE");
        $(`#${SDIConstants.SDILoader}`).addClass('hide');


    }
    ExportToExcelClick = () => {

        let excelbo = {
            UserId: CookieService.getLocalStorageValues("Session_UserID"),
            EventNo: this.state.eventselected,
            BUSUNIT: this.state.cribselected
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ReconAction.ExportData(excelbo);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    handleCheckbox = (e, inde) => {
        //debugger

        var data = [...this.state.PageGridArr];
        let ItemReadyCount = this.state.CountedItemReadyForUpdate;
        data[inde].ISA_UPDT_READY = data[inde].ISA_UPDT_READY == 'TRUE' ? "FALSE" : "TRUE";
        if (data[inde].ISA_UPDT_READY == 'TRUE') {
            ItemReadyCount += 1;
        }
        else {
            ItemReadyCount = ItemReadyCount - 1;
        }
        this.setState({ PageGridArr: data, CountedItemReadyForUpdate: ItemReadyCount });
        //WW-485 CYCLE COUNT FINALIZATION PAVITHRA R[09/02/2022]

        //let unupdateArr = [];
        //let checkornot = false;
        //this.state.PageGridArr.map((Item, index) => {
        //    checkornot = $(`#check-${this.state.pageNo}${index}`).is(":checked") ? true : false;
        //    if (checkornot == false) {
        //        let obj = { Item: Item, index: index }
        //        unupdateArr.push(obj);
        //    }
        //})

        //if (unupdateArr.length > 0) {
        //    $(`#finalizID`).prop('disabled', true)
        //} else {
        //    $(`#finalizID`).prop('disabled', false)
        //}
    }


    FinalizationClick = () => {


        this.UpdateClick();




        let finalBo = {
            UserId: CookieService.getLocalStorageValues("Session_UserID"),
            EventNo: this.state.eventselected,
            BUSUNIT: this.state.cribselected
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        /*[02/17/22, PC_01 WBW-34], Priyanka D, Saving the changes before finalizing */


        ReconAction.FinalRecon(finalBo);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        // $(`#finalize_modal`).modal('show');
        $(`#finalizID`).prop('disabled', true)
        $(`#reconID`).prop('disabled', true)
        //  $(`#saveID`).prop('disabled', true)
        //$(`#recongridID`).hide();
        //$(`#datagridrecon`).hide();
        //$('#recongridID').css('display', 'none')


        this.state.PageGridArr.map((order, index) => {
            $(`#updaterecon${index}`).prop('disabled', true)
        })
        $(`#cribID`).prop('disabled', true)
        $(`#finalizID`).prop('disabled', true)

        // $(`#saveID`).prop('disabled', true)
        // $(`#countevent`).prop('disabled', true)



    }


    //LoadRecon = () => {
    //    let loadBO = {
    //        UserId: CookieService.getLocalStorageValues("Session_UserID"),
    //        EventNo: this.state.eventselected,
    //        BUSUNIT: this.state.cribselected
    //    }

    //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    //    ReconAction.LoadRecon(loadBO);
    //}


    ReconUpdateResponse = () => {
        //this.state.PageGridArr.map((item, index) => {
        //    $(`#check-${this.state.pageNo}${index}`).prop('checked', item.ISA_UPDT_READY == "TRUE" ? true : false);
        //})
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');



        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //CPW-95 Finalizing after flag updation, Vishwa S
        if (isFinalize) {
            isFinalize = false;

            let finalBo = {
                UserId: CookieService.getLocalStorageValues("Session_UserID"),
                EventNo: this.state.eventselected,
                BUSUNIT: this.state.cribselected
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            /*[02/17/22, PC_01 WBW-34], Priyanka D, Saving the changes before finalizing */


            ReconAction.FinalRecon(finalBo);
            //$(`#${SDIConstants.SDILoader}`).addClass('hide');
            // $(`#finalize_modal`).modal('show');
            $(`#finalizID`).prop('disabled', true)
            $(`#reconID`).prop('disabled', true)
            //  $(`#saveID`).prop('disabled', true)
            //$(`#recongridID`).hide();
            //$(`#datagridrecon`).hide();
            //$('#recongridID').css('display', 'none')


            this.state.PageGridArr.map((order, index) => {
                $(`#updaterecon${index}`).prop('disabled', true)
            })
            $(`#cribID`).prop('disabled', true)
            $(`#finalizID`).prop('disabled', true)
        }
        else {
            this.ReconGridLoadData(this.state.pageNo, this.state.cribselected, this.state.eventselected);
        }
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');

    }

    SaveClick = () => {
        //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.setState({
            SearchBy: "All", srchTxt: " ", STrDisplayName: "All"
        });
        $('#searchInput').val('');
        this.UpdateClick();
    }


    FileExport = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let expfile = JSON.parse(ReconStore.Excel);

    }
    EventDropDown = (event) => {

        if (this.state.EventArray != undefined && this.state.EventArray != "") {
            if (this.state.EventArray.length > 0) {
                return this.state.EventArray.map((val, index) => {
                    //if (val.count_event != event) {
                    return (<option value={val.count_event}>{val.count_event}</option>)
                    // }
                });
            }
        }

    };

    actiondropdown = (action) => {

        if (this.state.ActionArray != undefined && this.state.ActionArray != "") {
            if (this.state.ActionArray.length > 0) {
                return this.state.ActionArray.map((val, index) => {
                    if (val.FIELDVALUE != action && val.ISA_ACTION != 'Research') {
                        return (<option value={val.FIELDVALUE}>{val.ISA_ACTION}</option>)
                    }
                });
            }
        }
    }
    CribDropDown = (crib) => {
        //debugger
        if (this.state.CribArray != undefined && this.state.CribArray != "") {
            if (this.state.CribArray.length > 0) {
                return this.state.CribArray.map((val, index) => {
                    return (<option value={val.BUSINESS_UNIT_IN}>{val.DESCR}</option>)//WBW-15_PC_05 to display the crib name (2/18/2022) -Aparna

                });
            }
        }

    };
    STrDropDown = (event, displayName, columnName) => {
        event.preventDefault();
        let searchTrBy = columnName;

        this.setState({ SearchBy: searchTrBy, STrDisplayName: displayName });
    }
    //Bug-2332-Cycle Count Reconciliation panel - Filter option is not working for Item ID, Variance and Location.[7/11/2022] - Dhamotharan P
    handleToggle = (e, toggle) => {
        this.setState({ toggleChecked: !toggle });
        this.handleSearch(e, "Toggle")


    }
    AnykeyHeaderPress = (e) => {
        if (e.keyCode == 13) {
            this.handleSearch(e, "search")
        }
    };
    handleSearch = (e, searchType) => {

        //debugger

        let isFilterSrc = "";
        if (searchType == "Toggle") {
            isFilterSrc = this.state.toggleChecked == false ? "TRUE" : "FALSE";
        }
        else {
            isFilterSrc = this.state.toggleChecked == false ? "FALSE" : "TRUE";
        }
        if (this.state.SearchBy == "ItemReadyUpd") {
            let searchtext = this.state.srchTxt.toUpperCase();
            if ((searchtext == "YES") || (searchtext == "TRUE") || (searchtext == "Y")) {
                this.state.srchTxt = "Y";
            }
            if ((searchtext == "NO") || (searchtext == "FALSE") || (searchtext == "N")) {
                this.state.srchTxt = "N";
            }
        }
        let searchBO = {
            PageNo: this.state.pageNo,
            ItemCount: this.state.itemCount,
            CribIdent: this.state.cribselected,
            EventNo: this.state.eventselected,
            SearchBy: this.state.SearchBy,
            SearchTxt: this.state.STrDisplayName == 'Item Ready For Update' ? "N" : this.state.srchTxt,
            IsFilter: isFilterSrc,

            //bug 4209 -Yuvarani K
            Storage_area: Storage_Area ? Storage_Area: " ",
            Stor_level_1: Store_level_1 ? Store_level_1 : " ",
            Stor_level_2: Store_level_2 ? Store_level_2 : " ",
            Stor_level_3: Store_level_3 ? Store_level_3 : " ",
            Stor_level_4: Store_level_4 ? Store_level_4 : " "

        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //debugger
        ReconAction.ReconSearch(searchBO);
    }

    handleCribChange = (event) => {
        let cribIdent = event.target.value.substring(1, event.target.value.length)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        $(`#finalizID`).prop('disabled', true)
        $(`#reconID`).prop('disabled', true)

        isPageload = true; //CPW-95 to set to default page after Finalization click, Vishwa S
        this.ReconGridLoadData("1", cribIdent, "");
        this.setState({ cribselected: cribIdent, pageNo: "1", EventArray: [], eventselected: "", toggleChecked: false /*, isPageload: true*/ }); //CPW-95 to set to default page after Finalization click, Vishwa S
    }

    handleEventChange = (event) => {
        //debugger
        let countevent = event.target.value
        $(`#countevent`).prop('disabled', false)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide')
        //if (countevent == "") {
        //    $(`#finalizID`).prop('disabled', true)
        //}
        //$(`#countevent`).prop('disabled', false)     
        console.log("this.state.eventselected", countevent)
        //5632 - update  a filter state to default [4/17/25] Nachiappan
        this.setState({
            eventselected: countevent, EventArray: [], toggleChecked: false, SearchBy: "All", srchTxt: " ", STrDisplayName:"All"
        });
        $('#searchInput').val('');
        this.ReconGridLoadData("1", this.state.cribselected, countevent);
    }
    handleApprove = (val) => {
        console.log("approvalvalue", val);
        if (val == "Yes") {
            this.UpdateClick();
        }
        this.state.UpdateAgree = val;
    }
    //handleEventChange = (event) => {
    //    let eventval = event.target.value
    //    console.log("eventval", eventval);
    //    this.setState({ eventselected: eventval});
    //}

    handleDropdownChange = (e, index) => {
        let actionval = e.target.value
        this.state.PageGridArr[index].actionSelected = actionval
        this.setState({ ActionNew: actionval });
    }

    getSearchText = (e) => {
        let searchVal = e.target.value;

        //bug 4209 -Yuvarani K
        words = searchVal.split(' ');
        Storage_Area = words[0];
        Store_level_1 = words[1];
        Store_level_2 = words[2];
        Store_level_3 = words[3];
        Store_level_4 = words[4];

        this.setState({ srchTxt: searchVal });
    }
    ReconPageLoadData = () => {

        //$('#myTabContent').addClass('show');
        //$('#mycountedTabContent').addClass('hide');
        let ReconPageLoadBO = {
            UserId: CookieService.getLocalStorageValues("Session_UserID")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ReconAction.ReconPageLoad(ReconPageLoadBO);
    }
    ReconPageLoadDataResponse = () => {
        //debugger
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        let ReconResponse = JSON.parse(ReconStore.PageLoadData);
        let isaeventarray = ReconResponse.IsaEventTable;


        let isacribarray = ReconResponse.Table;
        let isaUserBU = ReconResponse.IsaUserBU;


        let eventdropdown = [];
        let Countevent = "";



        if (ReconResponse.IsaCountEvnt != undefined && ReconResponse.IsaCountEvnt[0].CountEvent != "") {
            ReconResponse.IsaCountEvnt.forEach((value, index) => {

                Countevent = value.CountEvent
                eventdropdown.push({
                    //count_event: value.CountEvent
                    count_event: Countevent

                })


            })
        }


        if (isaeventarray != undefined && isaeventarray != "") {
            isaeventarray.forEach((value, index) => {
                if (Countevent != value.COUNTINGEVENT) {
                    eventdropdown.push({
                        count_event: value.COUNTINGEVENT
                    })
                }
            })

        }
        let event = []
        //if (isaeventarray != undefined) {
        $(`#cribID`).prop('disabled', false)
        $(`#countevent`).prop('disabled', false)
        $(`#reconID`).prop('disabled', true)
        if (isaeventarray == "" || isaeventarray == undefined) {
            $('#no_event_modal').modal('show');
            document.getElementById("finaldetail").innerText = " has no events for FINALIZATION." //CPW-95 Vishwa S

            $(`#countevent`).prop('disabled', true)
            $(`#finalizID`).prop('disabled', true)
            $(`#exportID`).prop('disabled', true)
            // $(`#saveID`).prop('disabled', true)
            // cntdevnt = "--Select--";




            if (isaeventarray.length > 0) {
                // $(`#finalizID`).prop('disabled', false)
                $(`#exportID`).prop('disabled', false)
                //$(`#saveID`).prop('disabled', false)
                event = isaeventarray
            }
            this.setState({ GridData: true })
        }



        //if (isaeventarray != undefined) {
        //    $(`#cribID`).prop('disabled', false)
        //    $(`#countevent`).prop('disabled', false)
        //    $(`#finalizID`).prop('disabled', true)
        //    if (isaeventarray == "") {
        //        $('#no_event_modal').modal('show');
        //        $(`#finalizID`).prop('disabled', true)
        //        $(`#exportID`).prop('disabled', true)
        //        $(`#saveID`).prop('disabled', true)
        //        if (this.state.CribArray.length == 1) {
        //            $(`#cribID`).prop('disabled', true)
        //            $(`#countevent`).prop('disabled', true)
        //        }
        //    }
        //    else {
        //        if (isaeventarray.length > 0) {

        //            event = isaeventarray
        //            if (this.state.eventselected != '--Select--') {
        //               //  $(`#finalizID`).prop('disabled', false)
        //                $(`#exportID`).prop('disabled', false)
        //                $(`#saveID`).prop('disabled', false)
        //            }
        //        }
        //    }

        //}
        let cribselect = isaUserBU[0].UserBU
        let cribname = ""
        if (isacribarray != undefined) {
            if (isacribarray.length > 0) {
                isacribarray.forEach((x) => {

                    if (x.BUSINESS_UNIT_IN.substring(1, x.BUSINESS_UNIT_IN.length) == isaUserBU[0].UserBU) {
                        cribselect = x.BUSINESS_UNIT_IN
                        cribname = x.DESCR
                    }
                })
            }
        }

        isPageload = true //CPW-95 to set to default page after Finalization click, Vishwa S
        this.setState({
            EventArray: eventdropdown,
            CribArray: isacribarray,
            cribselected: isaUserBU[0].USERBU,
            cribselectedshow: cribselect,
            eventselected: ""
        });

    }

    ReconGridLoadDataResponse = () => {
        let ReconResponse = JSON.parse(ReconStore.GridLoadRecon);
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
        let Reconaray = ReconResponse.PageLoadTable;
        let CountStatusarray = ReconResponse.CntStatus;
        let isaeventarray = ReconResponse.IsaEventTable;
        let isaactionarray = ReconResponse.IsaActionDT;
        let ItemReadyCount = 0;

        let tc = 0;
        let cntdevnt = "";

        //let eventdropdown = this.state.EventArray != null && this.state.EventArray != undefined && this.state.EventArray != [] ? this.state.EventArray : []
        let eventdropdown = []
        let Countevent = "";


        if (ReconResponse.IsaCountEvnt != undefined && ReconResponse.IsaCountEvnt[0].CountEvent != "") {
            ReconResponse.IsaCountEvnt.forEach((value, index) => {

                Countevent = value.CountEvent
                eventdropdown.push({

                    count_event: Countevent

                })


            })
        }


        if (isaeventarray != undefined && isaeventarray != "") {
            isaeventarray.forEach((value, index) => {
                if (Countevent != value.COUNTINGEVENT) {

                    eventdropdown.push({
                        count_event: value.COUNTINGEVENT
                    })
                }


            })


        }

        {/* else if (this.state.eventselected != undefined && this.state.eventselected != "") {
            cntdevnt = this.state.eventselected
            this.setState({ eventselected: cntdevnt })
        }
        */}


        if (CountStatusarray != undefined && CountStatusarray != "") {
            if (CountStatusarray.length > 0) {

                //cntstatus = CountStatusarray[0].COUNT_STATUS;
                this.checkStatus(CountStatusarray, eventdropdown);
            }
        }
        else {

            $(`#reconID`).prop('disabled', true)
        }

        if (Reconaray != undefined && Reconaray != "") {
            if (Reconaray.length > 0) {
                $(`#countevent`).prop('disabled', false)
                tc = Reconaray[0].TOTAL_COUNT;
                Reconaray.forEach((value, index) => {
                    value.EnteredQty = value.ACTUAL_QUANTITY;
                    value.actionSelected = value.ISA_ACTION;
                    if (value.ISA_UPDT_READY == 'TRUE') {
                        ItemReadyCount += 1;
                    }


                });

            };
        }

        let event = []
        if (isaeventarray != undefined) {
            $(`#cribID`).prop('disabled', false)
            $(`#countevent`).prop('disabled', false)
            if (isaeventarray == "" || isaeventarray == undefined) {
                $('#no_event_modal').modal('show');
                document.getElementById("finaldetail").innerText = " has no events for FINALIZATION."  //CPW-95 Vishwa S

                $(`#countevent`).prop('disabled', true)
                $(`#finalizID`).prop('disabled', true)
                $(`#exportID`).prop('disabled', true)
                //  $(`#saveID`).prop('disabled', true)
                cntdevnt = "--Select--";
                if (this.state.CribArray.length <= 1) {
                    $(`#cribID`).prop('disabled', true)
                    $(`#countevent`).prop('disabled', true)
                }


                else {

                    if (isaeventarray.length > 0) {
                        // $(`#finalizID`).prop('disabled', false)
                        $(`#exportID`).prop('disabled', false)
                        //    $(`#saveID`).prop('disabled', false)
                        event = isaeventarray
                    }
                }
                this.setState({ GridData: true })

            }
            else if (this.state.EventArray != undefined) {
                event = this.state.EventArray

            }
        }
        if (this.state.GridData == true) {
            this.setState({
                actualGridData: [],
                PageGridArr: [],
                totalCount: "0",
                pageCount: Math.ceil((tc > 0 ? tc : 0) / this.state.itemCount),
                EventArray: eventdropdown,
                ActionArray: isaactionarray,

                CountedItemReadyForUpdate: ItemReadyCount,
                GridData: false
            })
        }
        else {
            this.setState({
                actualGridData: Reconaray,
                PageGridArr: Reconaray,
                totalCount: tc,
                pageCount: Math.ceil((tc > 0 ? tc : 0) / this.state.itemCount),
                EventArray: eventdropdown,
                ActionArray: isaactionarray,
                finalization: Reconaray,
                CountedItemReadyForUpdate: ItemReadyCount
            })


            // this.setState({ GridData: false });


        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        //WW-485 CYCLE COUNT FINALIZATION PAVITHRA R[09/02/2022]

        {/*  let unupdateArr = [];
        let checkornot = false;
        this.state.PageGridArr.map((Item, index) => {
            checkornot = $(`#check-${this.state.pageNo}${index}`).is(":checked") ? true : false;
            if (checkornot == false) {
                let obj = { Item: Item, index: index }
                unupdateArr.push(obj);
            }
        })

        if (unupdateArr.length > 0) {
            $(`#finalizID`).prop('disabled', true)
        } else {
            $(`#finalizID`).prop('disabled', false)
        }*/}





    }


    checkStatus = (CountStatusarray, eventdropdown) => {
        /*[CPW-95 Commented the validation of ACTION and FINALDTTM since the SDIX_CYCLE_COUNT_FINAL_LOG table insertion & updation was removed, Vishwa S]*/
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
        //let action = CountStatusarray[0].ACTION;
        //let finaldttm = CountStatusarray[0].FINALDTTM;
        let cntstatus = CountStatusarray[0].COUNT_STATUS;


        if ((cntstatus == "") || (cntstatus == null)) {

            //if (action == "") {
            $(`#countevent`).prop('disabled', false)
            $(`#finalizID`).prop('disabled', true)
            $(`#reconID`).prop('disabled', false)

            //}
        }
        if ((cntstatus == "") || (cntstatus == null)) {
            //  if ((finaldttm == "" && action == "") || (finaldttm != "" && action == "RECON")) {
            {/*if (((finaldttm == "" || finaldttm == null) && action == "RECON")) {
               
                $('#no_event_modal').modal('show');
                $(`#recongridID`).prop('disabled', true)
                document.getElementById("finaldetail").innerText = "Event no " + this.state.eventselected + " is now undergoing RECON."
                this.setState({ GridData: true })
            }*/}
            //else {
            $(`#countevent`).prop('disabled', false)
            $(`#cribID`).prop('disabled', false)
            $(`#recongridID`).prop('disabled', false)
            $(`#reconID`).prop('disabled', false)



            //}
        }

        //CPW-95 items with Count_Status "4" will not displayed, Vishwa S
        //if (cntstatus == "4") {
        //    if (((finaldttm == "" || finaldttm == null) && (action == "" || action == null)) || ((finaldttm != "" && finaldttm != null) && action == "RECON")) {
        //        //    $(`#countevent`).prop('disabled', false)
        //        //  $(`#cribID`).prop('disabled', false)
        //        $(`#finalizID`).prop('disabled', true)
        //        $(`#reconID`).prop('disabled', false)
        //        $(`#recongridID`).prop('disabled', false)
        //       // $(`#saveID`).prop('disabled', true)

        //    }

        //    else {
        //        $('#no_event_modal').modal('show');
        //      //  $(`#countevent`).prop('disabled', false)
        //     //   $(`#cribID`).prop('disabled', false)
        //        $(`#finalizID`).prop('disabled', true)
        //        $(`#reconID`).prop('disabled', true)
        //        $(`#recongridID`).prop('disabled', true)
        //    //    $(`#saveID`).prop('disabled', true)
        //        $(`#exportID`).prop('disabled', true)

        //        document.getElementById("finaldetail").innerText = "Event no " + this.state.eventselected + " is now undergoing RECON."
        //        this.setState({ GridData: true })
        //    }
        //}
        if (cntstatus == "5") {
            //if (((finaldttm == "" || finaldttm == null) && (action == "" || action == null)) || ((finaldttm != "" && finaldttm != null) && action == "RECON")) {
            //  if ((finaldttm == "" && action == "") || (finaldttm != "" && action == "RECON")) {

            $(`#countevent`).prop('disabled', false)
            $(`#cribID`).prop('disabled', false)
            // $(`#finalizID`).prop('disabled', false)
            $(`#reconID`).prop('disabled', true)
            // document.getElementById("lblalert").innerText = " Event no " + this.state.eventselected + " has completed RECON. Please review and FINALIZE"


            //}
            //else {

            {/*$('#no_event_modal').modal('show');
            //    $(`#saveID`).prop('disabled', true)
              //  $(`#countevent`).prop('disabled', true)
                //$(`#cribID`).prop('disabled', true)
                $(`#exportID`).prop('disabled', true)
                $(`#finalizID`).prop('disabled', true)
                $(`#reconID`).prop('disabled', true)
                $(`#recongridID`).prop('disabled', true)

                document.getElementById("finaldetail").innerText = "Event no " + this.state.eventselected + " is now undergoing FINALIZATION."
                this.setState({ GridData: true })*/}
            {/*  this.state.PageGridArr.map((order, index) => {

                    $(`#updaterecon${index}`).prop('disabled', true)
                    $(`#check-${this.state.pageNo}${index}`).prop('disabled', true)
                    $(`#itemQuantity${index + 1}`).prop('disabled', true)
                    $(`#actiondrop${index + 1}`).prop('disabled', true)

                })*/}
            //}
        }
        //if (cntstatus == "7") {
        //    //CPW-95 to display completed finalization popup, Vishwa S
        //    //$('#no_event_modal').modal('show');
        //    $(`#exportID`).prop('disabled', true)
        //    $(`#finalizID`).prop('disabled', true)
        //    $(`#reconID`).prop('disabled', true)
        //    $(`#recongridID`).prop('disabled', true)

        //    $(`#countevent`).prop('disabled', false)
        //    $(`#cribID`).prop('disabled', false)
        //    document.getElementById("finaldetail").innerText = "Counting Event " + this.state.eventselected + " has completed FINALIZATION."
        //    //if (this.state.cribselected != " ") {
        //    //    this.ReconGridLoadData("1", this.state.cribselected, this.state.eventselected);
        //    //}
        //    this.setState({ GridData: true })

        //}
        //this.setState({ finaldttm: finaldttm, action: action, countstatus: cntstatus})
        this.setState({ countstatus: cntstatus })
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }


    ReconGridLoadData = (pageno, cribSelct, countevent) => {
       

        let gridBO = {
            UserId: CookieService.getLocalStorageValues("Session_UserID"),
            PageNo: '' + pageno,
            ItemCount: '' + this.state.itemCount,
            CribUnit: cribSelct,
            CntdEvent: countevent,
            IsFilter: this.state.toggleChecked == false ? "TRUE" : "FALSE"
            
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
       
        ReconAction.ReconGridLoad(gridBO);
        
        // $(`#finalizID`).prop('disabled', false)
        $(`#exportID`).prop('disabled', false)
        //  $(`#saveID`).prop('disabled', false)








        //
    }


    //ReconUpdateResponse = () => {


    //    let UpdateQtyResponse = JSON.parse(ReconStore.UpdateQty);
    //    let result = UpdateQtyResponse.Table1[0].lblDBErr1
    //    let updmsg = UpdateQtyResponse.Table1[0].ItemId + " " + result;

    //    $(`#${SDIConstants.SDILoader}`).addClass('hide');

    //    if (result == "successfully updated") {
    //        let qtyUpdated = UpdateQtyResponse.UpdateVal[0].qtyUpdate
    //        let actionUpdated = UpdateQtyResponse.UpdateVal[0].lblDactionUpdatedBErr1

    //        //$('#Success-alert').modal('show');
    //    }
    //    else {

    //        //$('#Success-alert').modal('show');
    //    }

    //}
    onquantityChange = (e, index) => {

        const re = SDIConstants.quantityRegEX;
        if (e.target.value === '' || re.test(e.target.value)) {
            let { PageGridArr } = this.state;
            this.state.PageGridArr[index].EnteredQty = e.target.value
            //this.state.PageGridArr[index].ACTUAL_QUANTITY = e.target.value
            this.setState({ PageGridArr: PageGridArr, qtyvalue: this.state.PageGridArr[index].EnteredQty })
        }
    };
    FinalizeClicked = () => {

        let unupdateArr = [];
        let checkornot = false;
        this.state.PageGridArr.map((Item, index) => {
            checkornot = $(`#check-${this.state.pageNo}${index}`).is(":checked") ? true : false;
            if (checkornot == false) {
                let obj = { Item: Item, index: index }
                unupdateArr.push(obj);
            }
        })

        //this.state.UnupdatedGridArr = unupdateArr;
        this.setState({ UnupdatedGridArr: [...this.state.UnupdatedGridArr, ...unupdateArr] })
        if (this.state.UnupdatedGridArr.length > 0) {
            $(`#confirm_message_unupdate`).modal('show');
        } else {
            this.UpdateClick();
        }
    }

    UpdateClick = () => {

        {/*   //debugger

        
        let unupdateArr = [];
        let checkornot = false;
        this.state.PageGridArr.map((Item, index) => {
            checkornot = $(`#check-${this.state.pageNo}${index}`).is(":checked") ? true : false;
            if (checkornot == false) {
                let obj = { Item: Item, index: index }
                unupdateArr.push(obj);
            }
        })
        if (unupdateArr > 0) {
            this.state.ItemUpdated = true;

        }
        else {
            this.state.ItemUpdated = false;

        }*/}
        let list = []

        //CPW-95 final qty field empty check, Vishwa S
        this.state.PageGridArr.map((Item, index) => {
            if (Item.EnteredQty == "" && Item.EnteredQty != 0) {
                finalQtyCheck = false
            }
        })
        if (finalQtyCheck) {
            this.state.PageGridArr.map((Item, index) => {

                let UpdateQuantityBO = {
                    ITEMID: Item.INV_ITEM_ID,
                    BUSUNIT: Item.BUSINESS_UNIT,
                    CRIB: Item.STORAGE_AREA,
                    AISLE: Item.STOR_LEVEL_1,
                    ROW: Item.STOR_LEVEL_2,
                    SHELF: Item.STOR_LEVEL_3,
                    BIN: Item.STOR_LEVEL_4,
                    ACTION: Item.ISA_ACTION,
                    RESERV: Item.QTY_RESERVED,
                    AVAIL: Item.QTY_AVAIL,
                    ACTQTY: Item.ACTUAL_QUANTITY,
                    COUNTEVENT: this.state.eventselected,
                    //ITMRDYTOUPD: $(`#check-${this.state.pageNo}${index}`).is(":checked") ? 'Y' : 'N',
                    ITMRDYTOUPD: Item.ISA_UPDT_READY == 'TRUE' ? 'Y' : 'N', //CPW-95 Vishwa S
                    CurntAction: Item.actionSelected,
                    CurntActQty: Item.EnteredQty
                }
                list.push(UpdateQuantityBO)

                $(`#check-${this.state.pageNo}${index}`).prop('checked', false);
            })
            let BO = {
                update: list
            }
            ReconAction.ReconUpdateQty(BO);

            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
        else {
            finalQtyCheck = true;
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter the Final Qty"
            });
        }






    }

    SuccessDone_Click = (e) => {
        this.ReconGridLoadData("1", this.state.cribselected, this.state.eventselected);
    }
    finalizeDone_Click = (e) => {
        this.setState({ PageGridArr: [], totalCount: "0" });
    }

    unupdaterecon = () => {
        return this.state.UnupdatedGridArr.map((item, index) => {
            return (
                <label className="confirm-label d-block" > Item: {item.itemid} is not updated.</label >
            )
        }
        )
    }

    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(ReconStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (ReconStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ReconStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ReconStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        //this.refreshMenu();
    };
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Reconciliation",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            ReconAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ReconAction.deleteFavPage(deleteFavPageBO)
        }
    };


    bindgriddata = () => {
        //debugger

        return this.state.PageGridArr.map((order, index) => {

            let stor1 = order.STOR_LEVEL_1;
            let stor2 = order.STOR_LEVEL_2;
            let stor3 = order.STOR_LEVEL_3;
            let stor4 = order.STOR_LEVEL_4;
            let location = order.STORAGE_AREA + " " + stor1 + " " + stor2 + " " + stor3 + " " + stor4;

            let checked = order.ISA_UPDT_READY;
            let page = this.state.pageNo;
            //let orderLineItemCount = this.state.favOrderLineItemData.filter((value, indexVal) => value.ORDER_NO == order.ORDER_NO).length;
            if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {
                return (
                    <div className="col-md-12 float-left mt-4 border-bottom" id="recongridID">
                        <div className="w-100 ml-4 float-left mb-4">
                            <div className="col-md-3 float-left">
                                <div className="col-md-5 float-left p-0">
                                    <label className="catalog-label"><Trans>ItemKey</Trans><span> </span><Trans>ID</Trans><span>:</span></label>
                                </div>
                                <div className="col-md-7 float-left p-0">
                                    <label className="catalog-label">{order.INV_ITEM_ID}</label>
                                </div>
                            </div>

                            <div className="col-md-3 float-left">
                                <div className="col-md-6 float-left p-0">
                                    <label className="catalog-label"><Trans>unitofmeasure_key</Trans><span>:</span></label>
                                </div>
                                <div className="col-md-3 float-left p-0">
                                    <label className="catalog-label">{order.UOM}</label>
                                </div>
                            </div>
                            <div className="col-md-6 float-left">
                                <div className="col-md-4 float-left p-0">
                                    <label className="catalog-label"><Trans>Description</Trans><span>:</span></label>
                                </div>
                                <div className="col-md-5 float-left p-0">
                                    <label className="catalog-label">{order.DESCR}</label>
                                </div>
                            </div>
                        </div>





                        <div className="w-100 ml-4 float-left mb-4">
                            <div className="col-md-3 float-left">
                                <div className="col-md-5 float-left p-0">
                                    <label className="catalog-label mt-2"><Trans> Business Unit</Trans><span>:</span></label>
                                </div>
                                <div className="col-md-4 float-left p-0">
                                    <label className="catalog-label mt-2">{order.BUSINESS_UNIT}</label>
                                </div>
                            </div>
                            <div className="col-md-3 float-left ">
                                <div className="col-md-6 float-left p-0">
                                    <label className="catalog-label mt-2"><Trans>Bin Location</Trans><span>:</span></label>
                                </div>
                                <div className="col-md-4 float-left p-0">
                                    <label className="catalog-label mt-2">{order.BIN_LOC}</label>
                                </div>
                            </div>
                            <div className="col-md-6 float-left">
                                <div className="col-md-4 float-left p-0">
                                    <label className="catalog-label"><Trans>Reconciliation Tag</Trans><span>:</span></label>
                                </div>

                                <div className="col-md-5 float-left p-0">
                                    <label className="catalog-label">{order.RECONTAG}</label>
                                </div>
                            </div>


                        </div>
                        <div className="w-100 ml-4 float-left mb-4">

                            <div className="col-md-3 float-left ">
                                <div className="col-md-5 float-left p-0">
                                    <label className="catalog-label"><Trans>System Quantity</Trans><span>:</span></label>
                                </div>
                                <div className="col-md-6 float-left p-0">
                                    <label className="catalog-label">{order.QTY_AVAIL}</label>
                                </div>
                            </div>
                            <div className="col-md-3 float-left">
                                <div className="col-md-6 float-left p-0">
                                    <label className="catalog-label"><Trans>Count</Trans><span> </span><Trans>Quantity</Trans><span>:</span></label>
                                </div>
                                <div className="col-md-4 float-left p-0">
                                    <label className="catalog-label">{order.QTY_COUNT}</label>
                                </div>
                            </div>
                            <div className="col-md-6 float-left">
                                <div className="col-md-4 float-left p-0">
                                    <label className="catalog-label"><Trans>Variance</Trans><span>:</span></label>
                                </div>




                                <div className="col-md-5 float-left p-0">
                                    <label className="catalog-label">$&nbsp;{order.ISA_DOLLAR_DIFF}</label>
                                </div>
                            </div>

                        </div>
                        <div className="w-100 ml-4 float-left mb-3">

                            <div className="col-md-3 float-left ">
                                <div className="col-md-5 float-left p-0">
                                    <label className="catalog-label mt-2"><span>Final Qty</span><span>:</span></label>
                                </div>
                                <div className="col-md-6 float-left p-0">
                                    {/* <input type="text" value="213.00" class="form-control" />*/}
                                    <input type="text" className="form-control  float-left catalog-inline-qty" name="itemQuantity" id={`itemQuantity${index + 1}`} value={order.EnteredQty} onChange={(e) => this.onquantityChange(e, index)} />

                                    {/*<input type="text" className="form-control" name="itemQuantity" id={`itemQuantity${index + 1}`} value={order.ACTUAL_QUANTITY} onChange={(e) => this.onquantityChange(e, index)} />  */}
                                </div>
                            </div>


                            <div className="col-md-3 float-left">
                                <div className="col-md-5 float-left p-0">
                                    <label className="catalog-label mt-2"><Trans>Action</Trans><span>:</span></label>
                                </div>
                                <div className="col-md-6 float-left p-0">
                                    <select className="form-control" id={`actiondrop${index + 1}`} onChange={(e) => this.handleDropdownChange(e, index)}>
                                        <option value={order.actionSelected}>{order.actionSelected == "A" ? "Adjustment" : order.actionSelected == "N" ? "None" : " "}</option>
                                        {this.actiondropdown(order.actionSelected)}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2 float-left " >

                                <div className="custom-control custom-checkbox mt-2  item-custom-control custcheck">


                                    <input type="checkbox" className="custom-control-input" onChange={(e) => this.handleCheckbox(e, index)} id={`check-${this.state.pageNo}${index}`} name={`example${index}`} checked={order.ISA_UPDT_READY == 'TRUE' ? true : false} />
                                    <label className="custom-control-label priority-checkbox filter-checkbox" htmlFor={`check-${this.state.pageNo}${index}`}><Trans>Item Ready For Update</Trans></label>
                                </div>
                            </div>
                        </div>
                    </div >





                )
            }
        })

    }

    render() {
        let gridlength = 0;
        if (this.state.actualGridData != null && this.state.actualGridData != undefined) {
            gridlength = this.state.actualGridData.length
        }

        let finalization = (this.state.countstatus == "5" && this.state.CountedItemReadyForUpdate == gridlength && gridlength != 0);

        /*[CPW-95 Commented the validation of ACTION and FINALDTTM since the SDIX_CYCLE_COUNT_FINAL_LOG table insertion & updation was removed, Vishwa S]*/
        //let finalization = ( ((this.state.countstatus == "5" && (this.state.finaldttm == "" || this.state.finaldttm == null) && (this.state.action == "" || this.state.action == null))
        //    || (this.state.countstatus == "5" && ((this.state.finaldttm != "" && this.state.finaldttm != null) && this.state.action == "RECON")))
        //    && (this.state.CountedItemReadyForUpdate == gridlength && gridlength != 0)) ? true : false;
        //console.log("final", ((this.state.countstatus == "5" && (this.state.finaldttm == "" || this.state.finaldttm == null) && (this.state.action == "" || this.state.action == null)) || (this.state.countstatus == "5" && ((this.state.finaldttm != "" && this.state.finaldttm != null) && this.state.action == "RECON")) && (this.state.CountedItemReadyForUpdate == gridlength && gridlength != 0)) ? true : false);
        //console.log("1", (this.state.countstatus == "5" && this.state.finaldttm == "" && this.state.action == "")?true:false)
        //console.log("2", (this.state.countstatus == "5" && this.state.finaldttm != "" && this.state.action == "RECON") ? true : false)
        console.log("3", (this.state.CountedItemReadyForUpdate == gridlength) ? true : false)
        console.log("3", gridlength)
        console.log("this.state.CountedItemReadyForUpdate", this.state.CountedItemReadyForUpdate)
        return (
            //<div className="container-fluid content-section">
            <div className="container-fluid content-section">
                <div className="row">
                    <div className="col-lg-12 float-left" >
                        <div className="col-md-12 page-heading mb-3 float-left p-0">
                            {/*<a data-toggle="collapse" href="#collapseOne" className="accordion-toggle float-left mobileacc-arrow">
                                <span className="accordion-arrow accordion-arrow-change" /></a>*/}
                            <h5 className="page-title"><Trans>Cycle Count Reconciliation</Trans></h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-1" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-1">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>

                        </div>
                    </div>
                    <div className="col-md-12 my-3">
                        <div className="row">
                            <div className="col-md-4 col-lg-4 mb-2 float-left px-2">
                                <div className="row">
                                    <div className="col-md-8 col-lg-4 float-left">
                                        <label className="catalog-label mt-2"><span>ISA </span><Trans>Crib Identifier</Trans><span>:</span></label>
                                    </div>
                                    <div className="col-md-12 col-lg-8 float-left">
                                        <select className="form-control w-100" id="cribID" onChange={(e) => this.handleCribChange(e)}>
                                            {/* <option value={this.state.cribselected}>{this.state.cribselected}</option>*/}
                                            {this.CribDropDown(this.state.cribselectedshow)}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-4 mb-2 float-left px-2">
                                <div className="row">
                                    <div className="col-md-8 col-lg-4 float-left">
                                        <label className="catalog-label mt-2"><span>ISA </span><Trans>Counting Event</Trans><span>:</span></label>
                                    </div>
                                    <div className="col-md-12 col-lg-8 float-left">
                                        <select className="form-control" id="countevent" value={this.state.eventselected} onChange={(e) => this.handleEventChange(e)}>
                                            <option value="">Select</option>
                                            {this.EventDropDown(this.state.eventselected)}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-4 text-right float-left px-2">
                                {gridlength > 0 ?
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-3 mr-2 mb-2" id="exportID" disabled={this.state.countstatus == "5" ? false : true} onClick={() => this.ExportToExcelClick()} ><Trans>Export to Excel</Trans></button> : null}



                                <button className="btn btn-primary custom-btn-primary primary-btn px-3 mr-2 mb-2" disabled={!finalization} id="finalizID"
                                    onClick={() => {
                                        this.UpdateClick();
                                        isFinalize = true;
                                    }}><Trans>Finalization</Trans></button>
                                {/*<button className="btn btn-primary custom-btn-primary primary-btn px-3 mr-2 mb-2" id="finalizID" disabled={true} onClick={() => this.FinalizationClick()}><Trans>Finalization</Trans></button>}*/}
                                {/*<button className="btn btn-primary custom-btn-primary primary-btn px-3 mr-2 mb-2" id="reconID" onClick={() => this.LoadRecon()}><Trans>Load Recon</Trans></button>*/}
                            </div>
                        </div>
                        {/*<div className="col-md-12 float-left  mb-2 mt-3">
                            <div className="w-100 float-left Reconspace">
                              
                            </div>
                        </div>*/}
                    </div>

                    <div className="col-md-12 my-3">
                        <div className="mb-2">

                            <div className="col-md-12 text-left">
                                {this.state.totalCount > 0 || this.state.toggleChecked ? <span><label className="quick-label" ><Trans>See not updated items</Trans>
                                    <Switch
                                        onChange={(e) => this.handleToggle(e, this.state.toggleChecked)}
                                        checked={this.state.toggleChecked}
                                        color="primary"
                                    /></label></span> : null}
                                {this.state.totalCount > 0 ? <span><button className="ml-3 btn btn-primary custom-btn-primary primary-btn  mr-2" id="saveID" onClick={() => this.SaveClick()} >Save Changes</button>
                                    <div className="mt-2 float-right text-right">
                                        <div className="dropdown float-left">
                                            <div className="input-group dropdown-search float-left mb-2">
                                                <div className="input-group-prepend">
                                                    <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >{this.state.STrDisplayName}</button>
                                                    <div className="dropdown-menu" style={{}}>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "All", " ")}><Trans>All</Trans></a>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "Item ID", "ItemID")}><Trans>Item</Trans><span> </span><Trans>ID</Trans></a>
                                                        {/* <a className="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "Item Ready For Update", "ItemReadyUpd")}><Trans>Item Ready For Update</Trans></a> */}
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "Location", "Location")}><Trans>Location</Trans></a>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "Reconciliation Tag", "ReconTag")}><Trans>Reconciliation Tag</Trans></a>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "Variance", "Variance")}><Trans>Variance</Trans></a>
                                                    </div>
                                                </div>
                                                {this.state.STrDisplayName == 'Item Ready For Update' ? <></> : <input type="text" className="form-control" placeholder="Search" onKeyDown={this.AnykeyHeaderPress} onChange={(e) => this.getSearchText(e)} aria-label="Text input with dropdown button" id="searchInput" />}
                                                <div className="input-group-append" data-toggle="modal" data-target="#quick-item-popup">
                                                    <span className="input-group-text srchBg-color" onClick={(e) => this.handleSearch(e, "search")} data-backdrop="static" data-keyboard="false">
                                                        <span className="shopping-search-icon" />
                                                    </span>
                                                </div>
                                                {/* <input type="text" className="form-control" placeholder="Search" aria-label="Text input with dropdown button" />
                                              <span className="dropdown-search-icon" onclick={(e)=>this.handleSearch(e)} />*/}
                                            </div>
                                        </div>
                                    </div></span> : null}

                            </div>
                            <span id="lblalert" className="DropDown-Font-Size lblalertcolour"></span>




                        </div>
                    </div>
                    <div className="col-md-12 my-3">
                        <div className="text-left">
                            <span><label className="quick-label catalog-label form-label" ><span className="err-msg text-danger">*</span><Trans>Note: All the items should be ready for update to finalize</Trans>
                            </label></span>     </div>
                    </div>
                    <div className="col-md-12 float-left mb-4 border-bottom}" style={{ "paddingRight": "5px" }}>
                        <div className="container-fluid content-margin">
                            <ul className="nav nav-tabs catalog-tabs-mobile catalog-tabs mt-4" id="myTab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" id="catalog-details-tab" data-toggle="tab" href="#catalog-details" role="tab" aria-controls="catalog-details" aria-selected="true"><Trans>Cycle Count Reconciliation</Trans></a>
                                </li>
                                { /*/<li className="nav-item">
                                      //    <a className="nav-link" id="item-details-tab" data-toggle="tab" href="#item-detail" role="tab" aria-controls="item-detail" aria-selected="false">Purchase History</a>
                                      //</li>
                                      //<li className="nav-item">
                                      //    <a className="nav-link" id="usage-tab" data-toggle="tab" href="#usage" role="tab" aria-controls="usage" aria-selected="false">Transactions</a>
                                      //</li>*/}
                            </ul>
                            {this.state.totalCount > 0 ? this.bindgriddata() :
                                (
                                    <section className="site-undercontruction container text-center center-panel pt-4">
                                        <div className="img-section">
                                            <img src="images/nosearch.jpg" alt="imagefile" />
                                        </div>
                                        <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                        </p>
                                    </section>
                                )}
                            <div className="tab-content catalog-tab-content Catalog-Items" id="myTabContent">
                            </div>
                            {this.state.totalCount > 0 ?
                                <div className="col-md-12 float-left mt-3">
                                    <span className="total-records mt-2 d-inline-block">
                                        <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.totalCount}</span>
                                    </span>
                                    {this.state.totalCount > this.state.itemCount ? <ReactPaginate
                                        previousLabel={<span className="right-pagination-arrow" />}
                                        nextLabel={<span className="left-pagination-arrow" />}
                                        previousClassName={'page-item'}
                                        nextClassName={'page-item'}
                                        previousLinkClassName={'page-link'}
                                        nextLinkClassName={'page-link'}
                                        disabledClassName={'disabled'}
                                        breakLabel={'...'}
                                        breakClassName={'page-item'}
                                        breakLinkClassName={'page-link'}
                                        pageCount={this.state.pageCount}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={2}
                                        onPageChange={this.handlePageClick}
                                        containerClassName={'custom-pagination pagination float-right'}
                                        pageClassName={'page-item'}
                                        pageLinkClassName={'page-link'}
                                        activeClassName={'active'}
                                        hrefBuilder={() => '#'}
                                        forcePage={this.state.pageNo - 1}
                                    /> : null}

                                </div> : null}
                        </div>
                    </div>
                </div>
                <div className="modal" id="Success-alert">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-3">
                                        <span className={` ${this.state.sucpopMsg == "Success!" ? 'success-alert-icon' : 'warning-icon'}`} />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block">{this.state.sucpopMsg}</label>
                                        <label className="confirm-label d-block"><Trans>Item</Trans><span> </span><Trans>ID</Trans><span> -</span> {this.state.sucpopItem} </label>
                                        {/*  <label className="confirm-content d-block">Item Has Been Updated Successfully</label>*/}
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" onClick={(e) => this.SuccessDone_Click(e)} data-dismiss="modal"><Trans>done_key</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="modal" id="finalize_modal">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header 
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body 
                            <div className="modal-body">
                                <div className="row text-center">

                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Crib</Trans><span> </span><Trans>Id</Trans><span>:</span> {this.state.cribselected} <Trans>Event</Trans><span> </span><Trans>No</Trans><span>:</span>{this.state.eventselected} has been finalized.</label>
                                        {/*<label className="confirm-label d-block"><Trans>Item</Trans><span> </span><Trans>ID</Trans><span> -</span> {this.state.sucpopItem} </label>*/}
                {/*  <label className="confirm-content d-block">Item Has Been Updated Successfully</label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" onClick={(e) => this.finalizeDone_Click(e)} data-dismiss="modal"><Trans>done_key</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>*/}

                <div className="modal" id="no_event_modal" data-backdrop="static">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            {/*<div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss={this.state.isPageload ? "modal" : undefined}
                                    onClick={this.state.isPageload ? undefined : () => {
                                        this.ReconGridLoadData("1", this.state.cribselected, "");
                                        $('#no_event_modal').modal('hide');
                                    }}>  {/*CPW-95 Vishwa S*/}
                            {/* X
              </button>
                            </div>*/}
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">

                                    <div className="col-md-12 mt-2 mb-2 text-center">
                                        <label className="confirm-label d-block"><Trans>Crib</Trans><span> </span><Trans>Id</Trans><span>:</span> {this.state.cribselected} <label id="finaldetail" className="confirm-label d-block"></label></label>
                                        {/*<label className="confirm-label d-block"><Trans>Item</Trans><span> </span><Trans>ID</Trans><span> -</span> {this.state.sucpopItem} </label>*/}
                                        {/*  <label className="confirm-content d-block">Item Has Been Updated Successfully</label>*/}
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss={isPageload ? "modal" : undefined}
                                            onClick={isPageload ? undefined : () => {
                                                this.ReconGridLoadData("1", this.state.cribselected, "");
                                                
                                                isPageload = true;
                                                $('#no_event_modal').modal('hide');
                                            }}>Done</button> {/*CPW-95 to trigger no events for FINALIZATION popup immediately after finalization, Vishwa S*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div className="modal" id="confirm_message_unupdate">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" ><Trans>Warning</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">

                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Not all items flagged for update. Contine?</Trans></label>
                                        {this.unupdaterecon}
                                        {/*<label className="confirm-label d-block"><Trans>Item</Trans><span> </span><Trans>ID</Trans><span> -</span> {this.state.sucpopItem} </label>*/}
                                        {/*  <label className="confirm-content d-block">Item Has Been Updated Successfully</label>*/}
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5 mr-3" data-dismiss="modal" onClick={() => this.handleApprove("No")} ><Trans>No</Trans></button>

                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.handleApprove("Yes")} ><Trans>Yes</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        );
    };
}
export default withTranslation()(ReconComponent);